export const HEADER_HEIGHT = 104;
export const TOUR_VIDEO_WIDTH = 1125;
export const TOUR_VIDEO_HEIGHT = 720;
